import React from 'react';
import { WEEKDAY_COLUMNS } from '../../utils/subscriptionDisplay';
import './SubscriptionSlotsPatternTable.css';

/**
 * Meal slots as rows, weekday delivery pattern as columns.
 *
 * @param {{
 *   rows: Array<{ slotLabel: string, days: string[], patternLabel: string, productName?: string, slotCode?: string }>,
 *   compact?: boolean,
 *   className?: string,
 *   emptyLabel?: string,
 * }} props
 */
export default function SubscriptionSlotsPatternTable({
  rows = [],
  compact = false,
  className = '',
  emptyLabel = '—',
}) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return <p className="slot-pattern-empty">{emptyLabel}</p>;
  }

  return (
    <div
      className={[
        'slot-pattern-wrap',
        compact ? 'slot-pattern-wrap--compact' : '',
        className,
      ].filter(Boolean).join(' ')}
    >
      <table className="slot-pattern-table">
        <thead>
          <tr>
            <th scope="col">Slot</th>
            {WEEKDAY_COLUMNS.map((day) => (
              <th key={day.key} scope="col">{day.short}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={`${row.slotCode || row.slotLabel}-${index}`}>
              <td className="slot-pattern-table__slot">
                <strong>{row.slotLabel}</strong>
                {row.productName ? <small>{row.productName}</small> : null}
              </td>
              {WEEKDAY_COLUMNS.map((day) => {
                const on = Array.isArray(row.days) && row.days.includes(day.key);
                return (
                  <td
                    key={day.key}
                    className={on ? 'slot-pattern-table__day--on' : 'slot-pattern-table__day--off'}
                    aria-label={`${day.short}: ${on ? 'yes' : 'no'}`}
                  >
                    {on ? '✓' : '·'}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
